import { createColumnHelper } from "@tanstack/react-table";
import StatusPillButtons from "components/Buttons/StatusPillButtons";
import CommonTooltip from "components/Tooltip/index";
import { PencilSimpleLineIcon } from "@phosphor-icons/react";
import Icon from "components/Icon/Icon";

const renderValue = (value) => {
  if (value === null || value === undefined || value.toString().trim() === "") {
    return "-";
  }
  return value;
};

const columns = (onEdit) => {
  const columnHelper = createColumnHelper();
  return [
    columnHelper.accessor("id", {
      header: "ID",
      size: 64,
      headerClassName: "table-header mono",
      cellClassName: "table-cell mono",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor((row) => row.companies?.company_name, {
      id: "company_name",
      header: "Company Name",
      size: 160,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => (
        <div className="truncate-text">{renderValue(info.getValue())}</div>
      )
    }),
    columnHelper.accessor((row) => row.signal_users?.name, {
      id: "signal_users_name",
      header: "Signal User Name",
      size: 176,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => (
        <div className="truncate-text">{renderValue(info.getValue())}</div>
      )
    }),
    columnHelper.accessor("import_file", {
      header: "Import File",
      size: 176,
      headerClassName: "table-header",
      cellClassName: "table-cell table-link",
      enableSorting: false,
      cell: (info) => {
        const value = info.getValue();
        return value && value.trim() !== "" ? (
          <div className="table-link">
            <a
              href={value}
              target="_blank"
              rel="noopener noreferrer"
              title={value}
            >
              {value}
            </a>
          </div>
        ) : (
          <span>-</span>
        );
      }
    }),
    columnHelper.accessor("status", {
      header: "Status",
      size: 160,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => {
        const value = info.getValue();
        return <StatusPillButtons status={value} dot={false} />;
      }
    }),
    columnHelper.accessor("conflict_file", {
      header: "Conflict File",
      size: 176,
      headerClassName: "table-header",
      cellClassName: "table-cell table-link",
      enableSorting: false,
      cell: (info) => {
        const value = info.getValue();
        return value && value.trim() !== "" ? (
          <div className="table-link">
            <a
              href={value}
              target="_blank"
              rel="noopener noreferrer"
              title={value}
            >
              {value}
            </a>
          </div>
        ) : (
          <span>-</span>
        );
      }
    }),
    columnHelper.accessor("total_creators_uploaded", {
      header: "Creators Uploaded",
      size: 160,
      headerClassName: "table-header mono",
      cellClassName: "table-cell mono",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor("new_creators_added_count", {
      header: "New Creators Added",
      size: 176,
      headerClassName: "table-header mono",
      cellClassName: "table-cell mono",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor("updated_creators_count", {
      header: "Updated Creators",
      size: 160,
      headerClassName: "table-header mono",
      cellClassName: "table-cell mono",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor("conflict_creators_count", {
      header: "Conflict Creators",
      size: 160,
      headerClassName: "table-header mono",
      cellClassName: "table-cell mono",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor("talent_company_id", {
      header: "Talent Company ID",
      size: 160,
      headerClassName: "table-header mono",
      cellClassName: "table-cell mono",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor("talent_manager_id", {
      header: "Talent Manager ID",
      size: 160,
      headerClassName: "table-header mono",
      cellClassName: "table-cell mono",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor("created_at", {
      header: "Created At",
      size: 176,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => (info.getValue() ? <>{info.getValue()}</> : "-")
    }),
    columnHelper.display({
      id: "actions",
      header: "",
      cellClassName: "actions",
      size: 50,
      enableSorting: false,
      cell: (info) => {
        const Status = info.row.original.status;

        if (Status === "imported" || Status === "completed") {
          return null;
        }

        return (
          <CommonTooltip
            theme="dark"
            tooltipContent="Update Roster Status"
            WrapperClass="talent-update-roster"
          >
            <div
              className="hover-actions"
              onClick={() => onEdit(info.row.original)}
            >
              <Icon
                component={PencilSimpleLineIcon}
                format="outline"
                weight="regular"
              />
            </div>
          </CommonTooltip>
        );
      }
    })
  ];
};

export default columns;
